import { ILogObj, Logger } from "tslog";

// Create a single logger instance
const logger: Logger<ILogObj> = new Logger({
    name: "Excel",
    type: "pretty",
    prettyLogTemplate: "{{yyyy}}-{{mm}}-{{dd}} {{hh}}:{{MM}}:{{ss}}:{{ms}} {{logLevelName}} [{{name}}] ",
    prettyLogTimeZone: "local",
    minLevel: process.env.NODE_ENV === "development" ? 3 : 2,
});

// Export convenience methods
export const log = {
    error: (...args: unknown[]) => logger.error(...args),
    warn: (...args: unknown[]) => logger.warn(...args),
    info: (...args: unknown[]) => logger.info(...args),
    debug: (...args: unknown[]) => logger.debug(...args),
    trace: (...args: unknown[]) => logger.trace(...args),
}; 